import React, {useContext, useMemo} from 'react';
import {UNSAFE_RouteContext as RouteContext} from 'react-router';
import {Routes} from 'react-router-dom';


function RootRoutes(props) {

    const context = useContext(RouteContext);

    const value = useMemo(
        () => ({
            ...context,
            matches: []
        }),
        [context]
    );

    return (
        <RouteContext.Provider
            value={value}
        >
            <Routes {...props}/>
        </RouteContext.Provider>
    );
}


export default RootRoutes;
